import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { setPlatformToken } from "../auth";

export default function PlatformLogin() {
  const navigate = useNavigate();
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const r = await api.post("/auth/platform-login", { username, password });
      setPlatformToken(r.data?.data?.access_token); navigate("/");
    } catch (x) { setErr(x?.response?.data?.message || x.message || "Login failed"); }
    setBusy(false);
  };
  return (
    <div className="login"><div className="box">
      <h2>Vxaro DPDP</h2><p>Platform Console</p>
      <form onSubmit={submit}>
        <div className="form-row"><label>Username</label><input value={username} onChange={(e) => setU(e.target.value)} autoFocus /></div>
        <div className="form-row"><label>Password</label><input type="password" value={password} onChange={(e) => setP(e.target.value)} /></div>
        <button className="btn primary" style={{ width: "100%" }} disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      {err && <div className="err">{err}</div>}
    </div></div>
  );
}
